import { Main } from "../components/merchants-inclusion-application/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 * 加盟店情報申請（包括）
 */
const MerchantInclusionApplication = () => {
  useAuthenticationHook(PERMISSIONS.APPLY);

  return <Main />;
};

export default MerchantInclusionApplication;
